import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  getters: {
    downloadUrl: (state) => {
      return `${config.serverURI}/attachmentDocuments/download`
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/attachmentDocument.js